<h1 mat-dialog-title>Aviso:</h1>
<div mat-dialog-content>{{ message }}</div><br>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Fechar</button>
</div>